import styled from '@emotion/styled';

const StyledDiv = styled.div(
  {
    alignItems: 'center',
    background: '#FFF1EE',
    borderRadius: '7px',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 13,
    paddingBottom: 14,
    paddingLeft: 20,
    paddingRight: 30,
    paddingTop: 14,
    textAlign: 'center',
    width: '100%'
  },
  ({ theme }) => ({
    border: `1px solid ${theme.palette.colors.wewak}`,
    color: theme.palette.colors.midnightBlue
  })
);

export default StyledDiv;
